import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface PersonLeaveLimitSettings {
  hourlyMonthlyLimit: number | null;
  hourlyYearlyLimit: number | null;
  dailyMonthlyLimit: number | null;
  dailyYearlyLimit: number | null;
}

export function leaveLimitMessage(error: any): string {
  return error?.error?.message || 'ثبت انجام نشد. ارتباط با سامانه و اطلاعات ورودی را بررسی کنید.';
}

@Injectable({ providedIn: 'root' })
export class PersonLeaveLimitSettingsService implements CanActivate {
  private readonly url = environment.BaseUrl + 'Daro/PersonLeaveLimitSettings';
  constructor(private http: HttpClient) { }
  get(): Observable<PersonLeaveLimitSettings> { return this.http.get<PersonLeaveLimitSettings>(this.url); }
  put(value: PersonLeaveLimitSettings): Observable<PersonLeaveLimitSettings> {
    return this.http.put<PersonLeaveLimitSettings>(this.url, value);
  }
  canActivate(): Observable<boolean> {
    // Backend authorizes the actual menu id using current database roles.
    return this.get().pipe(map(() => true), catchError(() => of(false)));
  }
}
